







































import Vue from 'vue'
import { YSveSwitchWithButtonInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'YSveSwitchWithButton',
  props: {
    templateItemData: {
      type: Object as () => YSveSwitchWithButtonInterface,
      required: true
    }
  },
  data: () => ({
    selected: false
  }),
  methods: {
    handleSwitchTextClick (event: Event): void {
      const link = event.target as HTMLInputElement
      if (link.closest('a')) {
        this.handleActionClick(
          this.templateItemData.switch.action
        )
      }
    }
  }
})
